import React from 'react'

import 'browser/components/atomic-elements/atoms/input/_pill-input.scss'
import _ from 'lodash'

interface IPillInputProps {
  onChange: (value: any) => void

  columns?: number
  options: any[]
  optionValuePath?: string
  optionLabelPath?: string
  enabledPath?: string
}

interface IPillInputState {
  value?: any
}

export class PillInput extends React.Component<IPillInputProps, IPillInputState> {
  public static defaultProps: Partial<IPillInputProps> = {
    columns: 4,
  }

  private columnsClasses: Record<number, string> = {
    1: 'c-pillInput-1wide',
    2: 'c-pillInput-2wide',
    3: 'c-pillInput-3wide',
    4: 'c-pillInput-4wide',
  }

  constructor(props: IPillInputProps) {
    super(props)

    this.state = {}
  }

  public render() {
    const { options } = this.props

    if (_.isEmpty(options)) {
      return <></>
    }

    return <div className="c-pillInput">{options.map(this.renderOption)}</div>
  }

  public renderOption = (option: unknown) => {
    const { optionLabelPath, enabledPath } = this.props
    const optionLabel = optionLabelPath ? _.get(option, optionLabelPath) : option
    const isDisabled = enabledPath ? !_.get(option, enabledPath) : false

    return (
      <div
        className={`c-pillInput-optionContainer ${this.getColumnsClass()}`}
        onClick={isDisabled ? undefined : () => this.selectOption(option)}
      >
        <div
          className={`c-pillInput-optionValue ${this.getSelectedClass(option)} ${isDisabled ? 'disabled' : ''}`}
        >
          {optionLabel}
        </div>
      </div>
    )
  }

  public getColumnsClass() {
    const { columns } = this.props
    return columns === undefined ? undefined : this.columnsClasses[columns]
  }

  public getSelectedClass(option: unknown) {
    return _.isEqual(option, this.state.value) ? 'c-pillInput-selected' : ''
  }

  public selectOption(option: unknown) {
    const { onChange, enabledPath } = this.props
    const { optionValuePath } = this.props
    const optionValue = optionValuePath ? _.get(option, optionValuePath) : option
    const isDisabled = enabledPath ? !_.get(option, enabledPath) : false

    if (isDisabled) {
      return
    }

    onChange?.(optionValue)

    this.setState({
      value: option,
    })
  }
}
